export default class UtilsNumber {
  /**
   * @deprecated use "toDecimals" instead
   */
  static toFloat(value) {
    return value ? parseFloat(String(value).replace(/[^0-9]/g, '')) / 100 : '';
  }

  static toDecimals(value, decimals = 2) {
    const factor = Math.pow(10, decimals);
    const truncatedNum = Math.trunc(value * factor) / factor;

    return parseFloat(truncatedNum.toFixed(decimals));
  }
}
